import { useQuery, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import type { Entity, HelperResult } from '@openclassrooms/sdk-web';
interface ApiError {
  statusCode: number;
}
export default function getUseGet<ParamsType, EntityType extends Entity, OptionsType = QueryObserverOptions>(get: (params?: ParamsType) => HelperResult<EntityType>, queryKey: string, withPermissions = false, withLinks = false): (getParams?: ParamsType, queryOptions?: OptionsType) => UseQueryResult<EntityType> {
  return (getParams, queryOptions) => useQuery({
    queryKey: [queryKey, getParams],
    queryFn: async () => {
      const {
        body: bodyResponse,
        links
      } = await get(getParams);
      const body = bodyResponse ?? (withPermissions || withLinks ? {} : bodyResponse);
      const reg = new RegExp(/^permission-(.*)$/);
      const permissions = links ? Object.keys(links).filter(link => link.match(reg)).map(link => link.replace(reg, '$1')) : [];
      const can = (permissionCode: string): boolean => permissions.some(permission => permission === permissionCode);
      if (withPermissions) {
        body.can = can;
      }
      if (withLinks) {
        body.links = links;
      }
      return body;
    },
    staleTime: 5000,
    retry: (failureCount, error) => {
      const statusCode = (error as unknown as ApiError)?.statusCode;
      if (statusCode >= 400 && statusCode < 500) {
        return false;
      }
      return failureCount < 3;
    },
    ...queryOptions
  });
}